// web-v2/src/lib/carrierRoles.js
//
// WHAT KIND OF THING IS THIS CARRIER ROW. Prompt 97 item 1 + amendment.
//
// The `carriers` table holds at least three kinds of thing and every picker over
// it wants a different one:
//
//   market       somewhere David sends a submission      Global, Starr, Beacon
//   paper        whose policy it is                      Markel
//   wholesaler   HOW it went, the answer to "how did     BWI, IBI, All Access
//                you send it"
//
// David: "In the markets list, wholesalers shouldn't exist. A wholesaler is a
// response to 'how did you send it.'" And on paper: "Markel is in the table
// because policies get issued on Markel paper. I don't write directly to Markel.
// I submit to PAU and they hold the pen."
//
// THE ROLES ARE NOT EXCLUSIVE. PAU is a market (3 submissions, 4 quotes against
// it) AND holds another carrier's pen. That is why these are two independent
// booleans rather than one `role` enum, which would have forced a wrong single
// answer on exactly that row.
//
// THIS IS NOT THE FILTER PROMPT 94 REMOVED, and the difference matters. That one
// filtered on ACCESS and line of business, off a premise David corrected: "a
// carrier i have no access to won't be in my list." His list IS his markets.
// This one does not ask whether he can reach a carrier, it asks whether the row
// is a market at all. Everything that is a market stays, unranked and unfiltered,
// however bad its history, and the free-text escape stays.

/** Somewhere a submission is sent. The market picker's population. */
export function isMarket(carrier) {
  return !!carrier && carrier.is_cobroker !== true && carrier.is_paper !== true;
}

/** Whose policy it is. Not somewhere you send anything. */
export function isPaper(carrier) {
  return !!carrier && carrier.is_paper === true;
}

/** How it went. The channel field's population, never the market picker's. */
export function isWholesaler(carrier) {
  return !!carrier && carrier.is_cobroker === true;
}

/** The market picker's list, in the order it was given. Sorts nothing. */
export function marketsOnly(carriers) {
  return (carriers || []).filter(isMarket);
}
